import useImport from "@verbleif/shared/src/composables/useImport";

useImport(); // Does nothing, it just gets imported so the code "runs"
